<template>
    <div>

        <v-row>
            <v-col class="py-2">
                <textFieldForm 
                    @valueChange="(v) => {values.Name = v; delete serverErrors.Name}" 
                    :valueInput="values.Name" 
                    :rule="rules.required" 
                    label="Nombre interno"
                    :errorMessages="serverErrors.Name"
                ></textFieldForm>
            </v-col>
        </v-row>

        <v-row>
            <v-col class="py-2">
                <textFieldForm 
                    @valueChange="(v) => {values.Description = v; delete serverErrors.Description}" 
                    :valueInput="values.Description" 
                    :rule="rules.required" 
                    label="Descripción"
                    :errorMessages="serverErrors.Description"
                ></textFieldForm>
            </v-col>
        </v-row>


        <v-row>
            <v-col class="py-2">
                <textFieldForm 
                    @valueChange="(v) => {values.Price = v; delete serverErrors.Price}" 
                    :valueInput="values.Price" 
                    :rule="[...rules.required, ...rules.amount]" 
                    label="Precio Unitario"
                    :errorMessages="serverErrors.Price"
                ></textFieldForm>
            </v-col>
        </v-row>

        

        <v-row>
            <v-col class="py-2">
                <autocompleteOneForm
                    label="Clave"
                    :searchInput="searchProductService"
                    :loading="loadingProductServices"
                    :valueInput="values.CodeProdServ"
                    :rule="rules.required"
                    :items="serverItems.prodServices"
                    :errorMessages="serverErrors.CodeProdServ"
                    @valueChange="(v) => {values.CodeProdServ = v; delete serverErrors.CodeProdServ}"
                    @searchChange="(v) => {changed(v)}"
                    :cache="true"
                ></autocompleteOneForm>
            </v-col>
        </v-row>

        <v-row>
            <v-col class="py-2">
                <autocompleteOneForm
                    label="Unidad"
                    :loading="loadingUnits"
                    :valueInput="values.UnitCode"
                    :rule="rules.required"
                    :items="serverItems.units"
                    :errorMessages="serverErrors.UnitCode"
                    @valueChange="(v) => {values.UnitCode = v; delete serverErrors.UnitCode}"
                ></autocompleteOneForm>
            </v-col>
        </v-row>

        <v-row>
            <v-col class="py-2">
                <autocompleteOneForm
                    label="Objeto Impuesto"
                    :valueInput="values.ObjetoImp"
                    :rule="rules.required"
                    :items="serverItems.objectTaxes"
                    :errorMessages="serverErrors.ObjetoImp"
                    @valueChange="(v) => {values.ObjetoImp = v; delete serverErrors.ObjetoImp}"
                ></autocompleteOneForm>
            </v-col>
        </v-row>


        <v-row>
            <v-col class="py-2">
                <autocompleteOneForm
                    label="IVA"
                    :valueInput="values.IVA"
                    :rule="[]"
                    :items="serverItems.iva"
                    :errorMessages="serverErrors.IVA"
                    @valueChange="(v) => {values.IVA = v; delete serverErrors.IVA}"
                ></autocompleteOneForm>
            </v-col>
            <!-- TODO -> agregar calc de inpuestos sobre proformas -->
            <v-col class="py-2">
                <autocompleteOneForm
                    label="IVA RET"
                    :rule="[]"
                    :items="[]"
                    :disabled="true"
                ></autocompleteOneForm>
            </v-col>
        </v-row>

        <!-- TODO -> agregar calc de inpuestos sobre proformas -->
         <v-row>
            <v-col class="py-2">
                <autocompleteOneForm
                    label="IEPS"
                    :rule="[]"
                    :items="[]"
                    :disabled="true"
                ></autocompleteOneForm>
            </v-col>
            <!-- TODO -> agregar calc de inpuestos sobre proformas -->
            <v-col class="py-2">
                <autocompleteOneForm
                    label="ISR"
                    :rule="[]"
                    :items="[]"
                    :disabled="true"
                ></autocompleteOneForm>
            </v-col>
        </v-row>



    </div>
</template>

<script>
import TableItems from "../incomes/TableItems.vue";
import Utils from '../../helpers/Utils';
import {ObjectTaxes} from "./ObjectTaxesValues"

/* eslint-disable */
export default {
    props: ['values', 'serverErrors', 'edit', 'inputCreditNotes'],
    components: {
       'table-items': TableItems
    },
    data(){
        return {
            ut: Utils,
            loadingProductServices: false,
            loadingUnits: false,
            searchProductService: "",
           
            rules: {
				required: [
					v => !!v || 'El campo requerido'
				],
               
                amount: [
                    v => {
                        if(v!= null && !v.toString().match("^[0-9]+(\.[0-9]{1,4})?$"))
                            return 'Solo números válidos';
                        if(v === null || v.toString().trim() === '')
                            return 'El campo es requerido'
                        return true;
                    }
                ],

                requiredIva: [
                    v => {
                        if(this.values.ObjetoImp == 2)
                            return 'El campo es requerido'
                        return true;
                    }
                ],
               
				current_mxn_per_usd: [
                    v => {
                        if(v!= null && !v.toString().match("^[0-9]+(\.[0-9]{1,4})?$"))
                            return 'Solo números válidos';
                        if(v === null || v.toString().trim() === '')
                            return 'El campo es requerido';
                        if(v === 0 || v === '0' || v<=0)
                            return 'El campo debe ser máyor a 1';
                        return true;
                    }
                ],
            },
            serverItems: {
                prodServices:[ 
                ],
                units: [
                ],
                iva: [
                    {text: "IVA 16%", value:"0.16"},

                ],
                objectTaxes: ObjectTaxes
            },

          
        }
    },
    computed: {
        
    },
    watch: { 

        [`values.CodeProdServ`](v) {
            console.log(v);
            this.values.NameCodeProdServ="";
            const found = this.serverItems.prodServices.find((x) => x.value == v);
            if(found != undefined)
                this.values.NameCodeProdServ = found.text.split("- ")[1]??''
            
        },
      
        [`values.UnitCode`](v) {
            console.log(v);
            this.values.Unit="";
            const found = this.serverItems.units.find((x) => x.value == v);
            if(found != undefined)
                this.values.Unit = found.text.split("- ")[1]??''
            
        },
      
        
    },
    mounted(){
        
        this.getProductServices(this.values.CodeProdServ);
        this.getUnits();
    },
    methods: {
        changed(v){
            console.log(v)
            
            if(v == null || v == '') return;
            if(v.length > 3){
                this.getProductServices(v)
            }
        },
       
        getProductServices(keyword)
        {
            if(keyword == undefined || keyword == null || keyword == '') return;
            // this.serverItems.prodServices = [];
            // this.values.CodeProdServ = '';
            this.loadingProductServices = true;
            this.$api.taxInvoice.productServices(keyword)
				.then((resp) =>{
					this.serverItems.prodServices = resp.data.map((x) => {
                        return {text: `${x.Value} - ${x.Name}`, value: x.Value}
                    });
				})
				.catch((error) =>{
					console.log(error, "error");
				})
				.finally(() => {
                    this.loadingProductServices = false;
				})
			;
        },

        getUnits()
        {
            this.loadingUnits = true;
            this.$api.taxInvoice.units()
				.then((resp) =>{
					this.serverItems.units = resp.data.map((x) => {
                        return {text: `${x.Value} - ${x.Name}`, value: x.Value}
                    });
				})
				.catch((error) =>{
					console.log(error, "error");
				})
				.finally(() => {
                    this.loadingUnits = false;
				})
			;
        },
    }
}
</script>

<style>

</style>